import gql from 'graphql-tag'

export const GET_PRODUCT_REVIEW_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getProductReviewPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        product {
          id
          titleEn
          titleKg
          titleRu
        }
        comment
        repliesCount {
          count
        }
        value
        createdAt
      }
    }
  }
`;

export const GET_PRODUCT_REVIEW_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductReview (
      data: {
        id: $id
      }
    ) {
      id
      product {
        id
        titleEn
        titleKg
        titleRu
      }
      client {
        id
        fullName
        image
      }
      comment
      value
      createdAt
    }
  }
`;
